import React from 'react';
import { UserContextType } from '.';
import UserContext from './context';

const useUser = (): UserContextType => React.useContext(UserContext);

export { useUser };
